
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.001 2S2.5 2 2.5 3s.501 1 .501 1H21s.501 0 .501-1-.501-1-.501-1H3zm.473 3h17l-2 18h-13l-2-18zm7-4c-1 0-1 1-1 1h5s0-1-1-1h-3zm-2 20h1l-1-16.037h-1l1 16.037zm7-16.037l-1 16.037h1l1-16.037h-1zm-4 0V21h1V4.963h-1z"}})])
          )
        }
      }
    